module.exports = __webpack_public_path__ + "svg/pisces.svg?2aaf1ea534f6548a93b82aaee6fe1cf5";